"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./AudioIcon.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var AudioIcon = function AudioIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-audio-icon"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-bar"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-bar"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-bar"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-bar"
  }));
};

AudioIcon.propTypes = {};
var _default = AudioIcon;
exports["default"] = _default;